import DomainalnApi from "@/api/domainaln";
import ReliableApi from "@/api/reliable";

let that;

export default {
    data() {
        return {

            //事件、工单、缺编 各自的统计维度
            ticketLevelTypeArr: ['LEVEL1', 'LEVEL2', 'LEVEL3'],
            workorderLevelTypeArr: ['LEVEL1', 'LEVEL2', 'LEVEL3', 'DRPLAN'],
            changeLevelTypeArr: ['LEVEL1', 'LEVEL2', 'LEVEL3'],
            authorizedsLevelTypeArr: [],
            registerLevelTypeValueArr: [],
            registerLevelTypeMap: {},

            dangerratioconfArr: [],     //全量安全系数配置

            ticketLevelArr: [],
            problemLevelArr: [],
            workorderLevelArr: [],
            changeLevelArr: [],
            authorizedsArr: [],
            registerLevelArr: [],

            reliableValueAvg: null,     //实时安全总指数

        }
    },

    methods: {

        async getRealtimeData() {
            await this.queryRegisterLevelInfo();
            await this.queryDangerRationConf();

            let ticketPromise = this.queryTicketInfo();

            let problemPromise = this.queryProblemInfo();

            let workorderPxromise = this.queryWorkorderInfo();

            let changePromise = this.queryChangeInfo();

            let registerPromise = this.queryRegisterInfo();

            let authorizedPromise = this.queryAuthorizedsInfo();

            Promise.all([ticketPromise, problemPromise, workorderPxromise, changePromise, registerPromise, authorizedPromise]).then(res => {
                this.convertTicketData(res[0]);
                this.convertProblemData(res[1]);
                this.convertWorkorderData(res[2]);
                this.convertChangeData(res[3]);
                this.registerLevelArr = this.convertXyData(res[4]);
                this.authorizedsLevelTypeArr = res[5].levels;
                this.convertAuthorizedData(res[5]);

                let ticketAllByDeptArr = this.countValue(this.ticketLevelArr, this.ticketLevelTypeArr, this.dangerratioconfArr, 'INCIDENT');
                let ticketAvg = this.bigNumAvg(ticketAllByDeptArr).toFixed(2);
                let workorderAllByDeptArr = this.countValue(this.workorderLevelArr, this.workorderLevelTypeArr, this.dangerratioconfArr, 'WORKORDER');
                let workorderAvg = this.bigNumAvg(workorderAllByDeptArr).toFixed(2);
                let authorizedAllByDeptArr = this.countValue(this.authorizedsArr, this.authorizedsLevelTypeArr, this.dangerratioconfArr, 'AUTHORIZED');
                let authorizedAvg = this.bigNumAvg(authorizedAllByDeptArr).toFixed(2);
                let problemAllByDeptArr = this.countValue(this.problemLevelArr, this.ticketLevelTypeArr, this.dangerratioconfArr, 'PROBLEM');
                let problemAvg = this.bigNumAvg(problemAllByDeptArr).toFixed(2);
                let changeAllByDeptArr = this.countValue(this.changeLevelArr, this.changeLevelTypeArr, this.dangerratioconfArr, 'CHANGE');
                let changeAvg = this.bigNumAvg(changeAllByDeptArr).toFixed(2);
                let registerAllByDeptArr = this.countValue(this.registerLevelArr, this.registerLevelTypeValueArr, this.dangerratioconfArr, 'REGISTER');
                let registerAvg = this.bigNumAvg(registerAllByDeptArr).toFixed(2);

                let distributionData = [ticketAvg, workorderAvg, authorizedAvg, changeAvg, problemAvg, registerAvg];
                this.renderDistributionChart(distributionData);     //安全指数分布

                let reliableValueArr = this.countReliableValueGBDept(ticketAllByDeptArr, workorderAllByDeptArr, authorizedAllByDeptArr, problemAllByDeptArr, changeAllByDeptArr, registerAllByDeptArr)
                this.renderReliableValueChart(reliableValueArr);    //部门安全指数

                let reliableValueAvg = this.bigNumAvg(reliableValueArr).toFixed(2);
                this.reliableValueAvg = reliableValueAvg;    //实时安全指数
            });
        },

        async queryRegisterLevelInfo() {
            await DomainalnApi.list({domainid: "ACCESSTYPE"}).then(res => {
                that.registerLevelTypeMap = new Map();
                that.registerLevelTypeValueArr = new Array();
                for (let i = 0; i < res.length; i++) {
                    that.registerLevelTypeMap.set(res[i].value, res[i].description);
                    that.registerLevelTypeValueArr.push(res[i].value);
                }
            });
        },

        async queryDangerRationConf() {
            await ReliableApi.getDangerratioconf().then(res => {
                this.dangerratioconfArr = res;
            });
        },

        queryTicketInfo() {
            let arr = [];
            for (let i = 0; i < this.deptids.length; i++) {
                arr.push(this.deptids[i] + '');
            }
            let params = {};
            params.deptids = arr;
            params.status = ['DRAFT', 'WACCEPT', 'WHANDLE'];
            params.clazz = 'INCIDENT';
            return ReliableApi.queryTicketChartInfo(params)
        },

        queryProblemInfo() {
            let arr = [];
            for (let i = 0; i < this.deptids.length; i++) {
                arr.push(this.deptids[i] + '');
            }
            let params = {};
            params.deptids = arr;
            params.status = ['DRAFT', 'WOPAN', 'WAPPR', 'WHOPAN', 'UNDETERMINED'];
            params.clazz = 'PROBLEM';
            return ReliableApi.queryTicketChartInfo(params);
        },

        queryWorkorderInfo() {
            return ReliableApi.queryWorkorderChartInfo(this.deptids + '', "WORKORDER");
        },

        queryChangeInfo() {
            return ReliableApi.queryWorkorderChartInfo(this.deptids + '', "CHANGE");
        },

        queryRegisterInfo() {
            let arr = [];
            for (let i = 0; i < this.deptids.length; i++) {
                arr.push(this.deptids[i] + '');
            }
            let params = {};
            params.deptids = arr;
            params.accesstypes = that.registerLevelTypeValueArr;
            return ReliableApi.queryRegisterChartInfo(params);
        },

        queryAuthorizedsInfo() {
            let params = {};
            params.deptids = this.deptids.toString();
            return ReliableApi.queryAuthorizedsChartInfo(params);
        },

        //转换数据结构，由按类型分组->按部门分组
        convertTicketData(responseBody) {
            this.ticketLevelArr = [];
            let ticketLevel1 = responseBody.level1List;
            let ticketLevel2 = responseBody.level2List;
            let ticketLevel3 = responseBody.level3List;
            for (let i = this.deptids.length - 1; i >= 0; i--) {
                let arr = new Array();
                arr.push(ticketLevel1[i]);
                arr.push(ticketLevel2[i]);
                arr.push(ticketLevel3[i]);
                this.ticketLevelArr.push(arr);
            }
            this.ticketLevelArr = this.ticketLevelArr.reverse();
        },

        convertProblemData(responseBody) {
            this.problemLevelArr = [];
            let problemLevel1 = responseBody.level1List;
            let problemLevel2 = responseBody.level2List;
            let problemLevel3 = responseBody.level3List;
            for (let i = this.deptids.length - 1; i >= 0; i--) {
                let arr = new Array();
                arr.push(problemLevel1[i]);
                arr.push(problemLevel2[i]);
                arr.push(problemLevel3[i]);
                this.problemLevelArr.push(arr);
            }
            this.problemLevelArr = this.problemLevelArr.reverse();
        },

        convertWorkorderData(responseBody) {
            this.workorderLevelArr = [];
            let workorderLevel1 = responseBody.level1Nums;
            let workorderLevel2 = responseBody.level2Nums;
            let workorderLevel3 = responseBody.level3Nums;
            let workorderDrillPlan = responseBody.drillPlanNums;
            for (let i = this.deptids.length - 1; i >= 0; i--) {
                let arr = new Array();
                arr.push(workorderLevel1[i]);
                arr.push(workorderLevel2[i]);
                arr.push(workorderLevel3[i]);
                arr.push(workorderDrillPlan[i]);
                this.workorderLevelArr.push(arr);
            }
            this.workorderLevelArr = this.workorderLevelArr.reverse();
        },

        convertChangeData(responseBody) {
            this.changeLevelArr = [];
            let changeLevel1 = responseBody.level1Nums;
            let changeLevel2 = responseBody.level2Nums;
            let changeLevel3 = responseBody.level3Nums;
            for (let i = this.deptids.length - 1; i >= 0; i--) {
                let arr = new Array();
                arr.push(changeLevel1[i]);
                arr.push(changeLevel2[i]);
                arr.push(changeLevel3[i]);
                this.changeLevelArr.push(arr);
            }
            this.changeLevelArr = this.changeLevelArr.reverse();
        },

        convertAuthorizedData(responseBody) {
            this.authorizedsArr = [];
            for (let i = this.deptids.length - 1; i >= 0; i--) {
                let arr = new Array();
                for (let j = 0; j < responseBody.nums.length; j++) {
                    for (let k = 0; k < responseBody.nums[j].length; k++) {
                        if (k == i) {
                            arr.push(responseBody.nums[j][k]);
                            break;
                        }
                    }
                }
                this.authorizedsArr.push(arr);
            }
            this.authorizedsArr = this.authorizedsArr.reverse();
        },

        /**
         * 交换二维数组横纵坐标
         * @param data
         */
        convertXyData(data) {
            if (data.length == 0) {
                return [];
            }
            let newArray = data[0].map(function (col, i) {
                return data.map(function (row) {
                    return row[i];
                })
            });
            return newArray;
        },

        /**
         * 实时安全指数页面-计算安全指数
         * @param levelArr          二维数组：纵向部门，横向事件/工单类型
         * @param levelTypeArr      事件/工单。。。类型（一级、二级、三级。。。）
         * @param dangerratioconfArr    危险系数
         * @param type INCIDENT,WORKORDER,AUTHORIZED,PROBLEM,CHANGE
         * @returns {Array}
         */
        countValue(levelArr, levelTypeArr, dangerratioconfArr, type) {
            let result = [];
            for (let k = 0; k < levelArr.length; k++) {
                let ticketScore = 1;
                for (let l = 0; l < levelArr[k].length; l++) {
                    let levelNum = levelArr[k][l];
                    let overFlag = false;  //是否缺编/多编(编制专用标志位)
                    if (levelNum < 0) {
                        overFlag = true;
                        levelNum = Math.abs(levelNum);
                    }
                    for (let m = 0; m < levelNum; m++) {
                        for (let n = 0; n < dangerratioconfArr.length; n++) {
                            if (dangerratioconfArr[n]['type'] == type) {
                                let dangerratio = dangerratioconfArr[n]['dangerratio'];
                                if (dangerratioconfArr[n]['level'] == levelTypeArr[l]) {
                                    if (overFlag) {          //多编
                                        ticketScore = this.$math.multiply(this.$math.add(this.$math.bignumber(1), this.$math.bignumber(parseFloat(dangerratio))), this.$math.bignumber(ticketScore));
                                    } else {
                                        ticketScore = this.$math.multiply(this.$math.subtract(this.$math.bignumber(1), this.$math.bignumber(parseFloat(dangerratio))), this.$math.bignumber(ticketScore));
                                    }
                                    break;
                                }
                            }
                        }
                    }
                }
                result.push(((ticketScore * 100) > 100 ? 100 : ticketScore * 100).toFixed(2));
            }
            return result;
        },

        /**
         * 高精度要求计算
         * @param math math.js
         * @param arr
         * @returns {number}
         */
        bigNumAvg(arr) {
            let sum = 0;
            for (let i = 0; i < arr.length; i++) {
                sum = this.$math.add(this.$math.bignumber(arr[i]), this.$math.bignumber(sum));
            }
            return this.$math.divide(this.$math.bignumber(sum), this.$math.bignumber(arr.length));
        },

        /**
         * 实时安全指数页面-计算数据中心安全指数
         * 安全指数=事件安全指数×40%+编制安全指数×20%+工单安全指数×10%+问题安全指数*10%+变更安全指数×10%+人员进出*10%
         * @param ticketAllByDeptArr
         * @param workorderAllByDeptArr
         * @param authorizedAllByDeptArr
         * @param problemAllByDeptArr
         * @param changeAllByDeptArr
         * @returns {any[]}
         */
        countReliableValueGBDept(ticketAllByDeptArr, workorderAllByDeptArr, authorizedAllByDeptArr, problemAllByDeptArr, changeAllByDeptArr, registerAllByDeptArr) {
            var result = new Array();
            for (var i = 0; i < ticketAllByDeptArr.length; i++) {
                var total = parseFloat(ticketAllByDeptArr[i]) * 0.4 + parseFloat(authorizedAllByDeptArr[i]) * 0.2
                    + parseFloat(workorderAllByDeptArr[i]) * 0.1 + parseFloat(problemAllByDeptArr[i]) * 0.1
                    + parseFloat(changeAllByDeptArr[i]) * 0.1 + parseFloat(registerAllByDeptArr[i]) * 0.1;
                result.push(total.toFixed(2));
            }
            return result;
        },
    },

    mounted(values) {
        that = this;
    },
}
